const BASE_URL = 'https://gallery.nothingtodo.me';

export interface PageMeta {
  title: string;
  description: string;
  image: string;
}

const metaByPath: Record<string, PageMeta> = {
  '/': {
    title: 'Déjà Gallery',
    description: 'Explore our current and upcoming exhibitions',
    image: `${BASE_URL}/images/cover.jpg`,
  },
  '/exhibitions/the-smoke': {
    title: 'The Smoke | Déjà Gallery',
    description: 'An exhibition exploring ephemeral moments and transient beauty',
    image: `${BASE_URL}/images/suzanna-hazy-days.jpg`,
  },
  '/exhibitions/mutating-wonders': {
    title: 'Mutating Wonders | Déjà Gallery',
    description: 'A solo exhibition exploring the thematic thread of Seeds, and its fragile state of in-between stages.',
    image: `${BASE_URL}/images/cover_MutatingWonders.jpg`,
  },
  '/exhibitions/in-outscape': {
    title: 'In : Outscape | Déjà Gallery',
    description: 'A dual exhibition exploring internal landscapes and outward expressions',
    image: `${BASE_URL}/images/InOutscape/Kotaro Yokomizo/uramichi8.jpeg`,
  },
  '/exhibitions/undo-redo': {
    title: 'Undo Redo | Déjà Gallery',
    description: 'Exploring fragile states of memory, choice, and alternate timelines',
    image: `${BASE_URL}/images/undo-redo/cover.jpg`,
  },
  '/projects': {
    title: 'Projects | Déjà Gallery',
    description: 'Artist residency and creative programs',
    image: `${BASE_URL}/images/cover.jpg`,
  },
};

export const getMetaForPath = (pathname: string, projectTitle?: string): PageMeta => {
  if (pathname.startsWith('/projects/') && projectTitle) {
    return {
      title: `${projectTitle} | Déjà Gallery`,
      description: 'Artist residency and creative programs',
      image: `${BASE_URL}/images/cover.jpg`,
    };
  }

  const basePath = pathname.replace(/\/[^/]+$/, '').replace(/\/$/, '') || '/';
  return metaByPath[pathname] ?? metaByPath[basePath] ?? metaByPath['/'];
};

export const updatePageMeta = (meta: PageMeta) => {
  document.title = meta.title;
  updateMetaTag('name', 'description', meta.description);
  updateMetaTag('property', 'og:title', meta.title);
  updateMetaTag('property', 'og:description', meta.description);
  updateMetaTag('property', 'og:image', meta.image);
  updateMetaTag('property', 'og:url', `${BASE_URL}${window.location.pathname}`);
  updateMetaTag('name', 'twitter:title', meta.title);
  updateMetaTag('name', 'twitter:description', meta.description);
  updateMetaTag('name', 'twitter:image', meta.image);
};

const updateMetaTag = (
  attr: 'name' | 'property',
  key: string,
  value: string
) => {
  const selector = attr === 'name' ? `meta[name="${key}"]` : `meta[property="${key}"]`;
  let el = document.querySelector(selector) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', value);
};
